import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CodeMetadata } from '../../../models';
import { CodeService } from '../../http/code/code.service';
import { map } from 'rxjs/operators';

@Injectable()
export class CodeFacade {
  constructor(private codeService: CodeService) {}

  getCodeMetadata(codeId: string): Observable<CodeMetadata> {
    return this.codeService.getCodeMetadata(codeId);
  }

  getExpirationDate(codeId: string): Observable<Date> {
    if (!codeId) {
      return of();
    }
    
    return this.getCodeMetadata(codeId).pipe(
      map((metadata: CodeMetadata) => {
        const expirationDate = new Date();

        expirationDate.setSeconds(expirationDate.getSeconds() + metadata.code_exp_seconds);

        return expirationDate;
      })
    );
  }
}
